import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface StatusCountRow {
  statusId: number;
  statusName: string;
  statusColour: string;
  count: number;
}

export interface ProductCountRow {
  productId: number;
  productName: string;
  themeColour: string | null;
  count: number;
}

export interface PlanCountRow {
  planId: number;
  planName: string;
  count: number;
}

export interface TrendPoint {
  date: string;
  count: number;
}

export interface DashboardSummary {
  statusCounts: StatusCountRow[];
  byProduct: ProductCountRow[];
  byPlan: PlanCountRow[];
  trend: TrendPoint[];
}

export interface ActionItemSection<T> {
  count: number;
  items: T[];
}

export interface ExpiringSoonItem {
  tenantId: number;
  tenantName: string;
  planName: string;
  daysUntilExpiry: number;
}

export interface ExpiredItem {
  tenantId: number;
  tenantName: string;
  daysOverdue: number;
}

export interface PendingPaymentItem {
  tenantId: number;
  tenantName: string;
  amount: string;
  currency: string;
}

export interface MandatoryConfigMissingItem {
  tenantId: number;
  tenantName: string;
  missingCount: number;
}

export interface FailedProvisioningItem {
  tenantId: number;
  tenantName: string;
  errorMessage: string | null;
  latestJobId: number;
}

export interface DashboardActionItems {
  expiringSoon: ActionItemSection<ExpiringSoonItem>;
  expired: ActionItemSection<ExpiredItem>;
  pendingPayment: ActionItemSection<PendingPaymentItem>;
  mandatoryConfigMissing: ActionItemSection<MandatoryConfigMissingItem>;
  failedProvisioning: ActionItemSection<FailedProvisioningItem>;
}

const getSummary = (trendDays: 30 | 90 = 30) => http.get(`${API_ENDPOINTS.dashboardSummary}?trendDays=${trendDays}`);

const getActionItems = () => http.get(API_ENDPOINTS.dashboardActionItems);

const DashboardService = { getSummary, getActionItems };

export default DashboardService;
